/* eslint-disable camelcase */
import { useState } from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';

import Image from 'next/image';
import { useRouter } from 'next/router';
import { Icon } from 'react-icons-kit';
import { ic_add } from 'react-icons-kit/md/ic_add';
import useIntlMessage from '@/hooks/use-intl-message';
// import { ic_view_list } from 'react-icons-kit/md/ic_view_list';
import { StyledUserNavbar } from '@/styles/index';
import AccountAvatar from '@/components/Layout/Navbar/AccountAvatar';
// import Tippy from '@/components/Tooltip';
import { createNewResponse } from '@/utils/data';
import { responseDataParser } from '@/utils/parser';
import useWindowSize from '@/hooks/use-window-size';

const Tippy = dynamic(() => import('@/components/Tooltip'), { ssr: false });

const FEEDBACK_FORM_ID = '955842a1-0636-4408-a7de-c414b33125ca';
const FEEDBACK_FORM_MESSAGE_KEY = 'FEEDBACK';
const FEEDBACK_FORM_PATHNAME_KEY = 'PATHNAME';

const FeedbackButton = ({ router }) => {
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [responseMessage, setResponseMessage] = useState(null);
  const { intlMessage: m } = useIntlMessage();

  const onSubmitFeedback = async () => {
    await setLoading(true);
    await setResponseMessage(null);
    const data = {
      [FEEDBACK_FORM_MESSAGE_KEY]: feedback,
      [FEEDBACK_FORM_PATHNAME_KEY]: router?.pathname
    };
    const parsed = responseDataParser(data);
    const responseBody = { pollID: FEEDBACK_FORM_ID, data: parsed };
    try {
      const { data: respData } = await createNewResponse(responseBody);
      const { response } = respData;
      if (response) {
        await setFeedback('');
        await setResponseMessage({
          status: 'success',
          message: 'Thank your for your message!'
        });
      }
    } catch (err) {
      console.log(err);
      await setResponseMessage({
        status: 'error',
        message: 'Something happened. Please refresh and try again'
      });
    } finally {
      await setLoading(false);
    }
  };

  return (
    <Tippy
      theme="light"
      placement="bottom"
      // trigger="click"
      visible={feedbackVisible}
      onClickOutside={() => setFeedbackVisible(false)}
      interactive
      maxWidth={250}
      // offset={[0, 1]}
      arrow={false}
      className="feedback-tooltip"
      content={
        <div className="feedback-block">
          <div className="field-wrapper">
            <textarea
              placeholder="Help us improve this page."
              value={feedback}
              onChange={e => setFeedback(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="feedback-block-footer">
            <div className="footer-actions">
              <button type="button" onClick={() => setFeedbackVisible(false)} disabled={loading}>
                {m({ id: 'cancel', route: 'layout.navbar_user_navbar' })}
              </button>
              <button
                type="button"
                className="btn-primary"
                onClick={onSubmitFeedback}
                // disabled={loading}
              >
                {m({ id: 'send_feedback', route: 'layout.navbar_user_navbar' })}
              </button>
            </div>
            <div className="footer-info">
              {m({ id: 'specific_issue', route: 'layout.navbar_user_navbar' })}{' '}
              <Link href="/contact">
                <a>{m({ id: 'support', route: 'layout.navbar_user_navbar' })}</a>
              </Link>{' '}
              {m({ id: 'check_our', route: 'layout.navbar_user_navbar' })}{' '}
              <Link href="/guides">
                <a>{m({ id: 'guides', route: 'layout.navbar_user_navbar' })}</a>
              </Link>
              .
            </div>
            {responseMessage && (
              <div className={`action-message ${responseMessage.status}`}>
                {responseMessage.message}
              </div>
            )}
          </div>
        </div>
      }
    >
      <button
        type="button"
        className="feedback-nav"
        onClick={() => setFeedbackVisible(!feedbackVisible)}
      >
        {m({ id: 'feedback', route: 'layout.navbar_user_navbar' })}
      </button>
    </Tippy>
  );
};

const UserNavbar = ({ session, user }) => {
  const router = useRouter();
  const { width } = useWindowSize();
  const { intlMessage: m } = useIntlMessage();
  const isPremium = session && session?.user?.premiumUser;
  return (
    <StyledUserNavbar>
      <div className="info-row">
        <div className="nav-context">
          <div className="nav-details-container">
            <div className="poll-details">
              {/**
                <div className="list-icon">
                  <Icon size={22} icon={ic_view_list} />
                </div>
               */}
              <Link href="/">
                <a className="nav-logo">
                  <Image src="/imgs/pollme_logo.png" alt="pollme nav-logo" layout="fill" />
                </a>
              </Link>
              {/**
                              session?.username && (
                  <Link href="/dashboard">
                    <a className="context-user">PollMe</a>
                  </Link>
                )
                 */}
            </div>
          </div>
        </div>
        <div className="nav-actions">
          <div className="nav-right">
            <Link href="/dashboard">
              <a className="nav-link">
                {m({ id: 'dashboard', route: 'layout.navbar_user_navbar' })}
              </a>
            </Link>
            <Link href="/templates">
              <a className="nav-link">
                {m({ id: 'templates', route: 'layout.navbar_user_navbar' })}
              </a>
            </Link>
            <FeedbackButton router={router} />
            {isPremium ? (
              <Link href="/create">
                <a>
                  <button className="new-poll-nav" type="button">
                    <Icon icon={ic_add} />{' '}
                    {width < 574
                      ? m({
                          id: 'new',
                          route: 'layout.navbar_user_navbar'
                        })
                      : m({
                          id: 'new_poll',
                          route: 'layout.navbar_user_navbar'
                        })}
                  </button>
                </a>
              </Link>
            ) : (
              <Link href="/premium">
                <a>
                  <button className="upgrade-nav" type="button">
                    {m({ id: 'upgrade', route: 'layout.navbar_user_navbar' })}
                  </button>
                </a>
              </Link>
            )}
          </div>
          <div className="account-btn">
            <AccountAvatar session={session} user={user} />
          </div>
        </div>
      </div>
    </StyledUserNavbar>
  );
};

export default UserNavbar;
